var _rect, _rect2, _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountConnectionSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.4497,
    width: 86.8346,
    height: 52.1008,
    rx: 9.6,
    fill: "url(#paint0_linear_3375_5858)",
    fillOpacity: 0.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 43.418,
    y: 48.1831,
    width: 34.7339,
    height: 8.68347,
    rx: 4.34173,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 64.5,
    r: 19.5,
    fill: "url(#paint1_linear_3375_5858)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 64.6667L75 70L85 58",
    stroke: "#DBF0E0",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3375_5858",
    x1: 86.8346,
    y1: 65.5505,
    x2: 2.02657,
    y2: 10.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3375_5858",
    x1: 112.714,
    y1: 108.793,
    x2: 21.4214,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317629,
    stopColor: "#00673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928169,
    stopColor: "#EEF9F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountConnectionSuccess);
export default __webpack_public_path__ + "static/media/account-connection-success.741bd9d51a365734d89b8a905802a9d1.svg";
export { ForwardRef as ReactComponent };